export default __webpack_public_path__ + "static/media/logo-us-fabkids.0544b463.svg";